module.exports = "<asui-loading-mask ng-if=\"$ctrl.asLoadingMask.showMask\" show=\"$ctrl.asLoadingMask.showMask\"></asui-loading-mask>\n";


//////////////////
// WEBPACK FOOTER
// ./modules/shared/components/asLoadingMask/asLoadingMask.component.html
// module id = 714
// module chunks = 0